import React, { useState } from 'react';
import styles from './Favorite.module.scss';
import Icon from './Icon/Icon';
import { useDispatch } from 'react-redux';
import {
    addEventToFavorites,
    removeEventToFavorites,
} from '../../../../../store/actions/favorites';

const Favorite = ({ isFavorite, programCode, id, isESports }) => {
    const dispatch = useDispatch();

    const [isSavingFavoriteState, setIsSavingFavoriteState] = useState(false);

    const toggleFavorite = async e => {
        e.stopPropagation();

        if (isSavingFavoriteState) return;
        setIsSavingFavoriteState(true);

        if (!isFavorite) {
            await dispatch(addEventToFavorites(id));
        } else {
            await dispatch(removeEventToFavorites(id));
        }

        setIsSavingFavoriteState(false);
    };

    return (
        <td className={styles.favorite} onClick={e => e.stopPropagation()}>
            {!isESports && (
                <Icon isFavorite={isFavorite} className={'m-b-1'} onClick={toggleFavorite} />
            )}
            <span className={styles.programCode}>{programCode}</span>
        </td>
    );
};

export default Favorite;
